var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompletedEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 186,
    height: 112,
    viewBox: "0 0 186 112",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42272_105379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.779 76.4155C186.79 92.5297 173.751 124.146 91.0581 102.174C49.5973 91.1567 18.6274 115.975 12.2458 98.6513C-2.61986 58.3008 58.0885 11.6244 91.8471 44.2115C122.704 73.998 161.379 47.0869 177.779 76.4155Z",
    stroke: "#E4E4E4",
    strokeMiterlimit: 10,
    strokeDasharray: "32.09 32.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.304 111.886H8.69629C13.973 72.9247 49.7018 42.7881 93.0004 42.7881C136.299 42.7881 172.028 72.9247 177.304 111.886Z",
    fill: "#F6F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.326 9.94629H91.9068C88.9544 9.94629 86.561 12.3382 86.561 15.2887V106.202C86.561 109.152 88.9544 111.544 91.9068 111.544H155.326C158.279 111.544 160.672 109.152 160.672 106.202V15.2887C160.672 12.3382 158.279 9.94629 155.326 9.94629Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.258 14.04H93.2588V102.592H154.258V14.04Z",
    fill: "#F6F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.257 14.041C154.276 48.5718 155.391 90.217 151.51 99.4375C134.415 101.102 114.398 101.636 93.2573 101.736L101.293 14.3077L154.257 14.041Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.778 96.6473C122.133 100.909 104.325 101.134 89.8804 100.062C91.752 80.15 92.5022 47.0705 93.2575 14.0449L125.366 14.1161L154.425 16.0332C154.849 50.311 154.895 81.9737 148.778 96.6473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.7891,
    y: 34.333,
    width: 18.1333,
    height: 56.6667,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.354 23.8565L105.986 23L105.856 28.5359L142.223 29.3924L142.354 23.8565Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.365 37.4034L116.562 36.6309L116.502 39.1646L149.305 39.9372L149.365 37.4034Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.728 42.6814L116.431 42.1562L116.371 44.69L138.668 45.2151L138.728 42.6814Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.061 43.1341L106.081 43.1063L104.207 40.8129L102.277 43.053L100.419 43.0269L103.172 39.9744L100.668 37.0365L102.581 37.0632L104.317 39.2437L106.073 37.1119L107.941 37.138L105.336 40.0741L108.062 43.1337L108.061 43.1341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.061 57.2084L106.081 57.1805L104.207 54.8872L102.277 57.1272L100.419 57.1011L103.172 54.0486L100.668 51.1107L102.581 51.1374L104.317 53.318L106.073 51.1861L107.941 51.2122L105.336 54.1483L108.062 57.208L108.061 57.2084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.061 70.809L106.081 70.7811L104.207 68.4878L102.277 70.7278L100.419 70.7017L103.172 67.6492L100.668 64.7113L102.581 64.738L104.317 66.9185L106.073 64.7867L107.941 64.8128L105.336 67.7489L108.062 70.8085L108.061 70.809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.061 85.5424L106.081 85.5145L104.207 83.2212L102.277 85.4612L100.419 85.4351L103.172 82.3826L100.668 79.4447L102.581 79.4714L104.317 81.6519L106.073 79.5201L107.941 79.5462L105.336 82.4823L108.062 85.5419L108.061 85.5424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.241 51.3764L116.228 50.7402L116.168 53.274L143.181 53.9102L143.241 51.3764Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.901 57.0372L116.098 56.2646L116.038 58.7984L148.841 59.571L148.901 57.0372Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.698 65.6222L115.895 64.8496L115.835 67.3834L148.638 68.156L148.698 65.6222Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.435 70.7205L115.765 70.375L115.705 72.9088L130.376 73.2543L130.435 70.7205Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.366 79.7316L115.563 78.959L115.503 81.4928L148.307 82.2653L148.366 79.7316Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.346 85.0937L115.432 84.4834L115.372 87.0172L141.286 87.6275L141.346 85.0937Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.355 10.5612V17.3959H109.878V10.5612C109.878 9.47141 110.321 8.48516 111.035 7.7692C111.124 7.68007 111.216 7.59668 111.314 7.51905C111.996 6.9526 112.873 6.61331 113.828 6.61331C114.545 6.61331 115.232 6.44941 115.848 6.15325C116.116 6.02386 116.369 5.87147 116.608 5.69607C117.393 5.11525 117.994 4.29003 118.294 3.30665C118.599 2.30316 119.223 1.46355 120.031 0.879858C120.808 0.322039 121.755 0 122.759 0H124.474C125.478 0 126.425 0.322039 127.201 0.879858C128.01 1.46355 128.634 2.30316 128.939 3.30665C129.238 4.29003 129.84 5.11525 130.625 5.69607C130.864 5.87147 131.117 6.02386 131.385 6.15325C132.001 6.44941 132.688 6.61331 133.405 6.61331C134.36 6.61331 135.237 6.9526 135.919 7.51905C136.797 8.24076 137.355 9.33627 137.355 10.5612Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.585 14.04V19.1208H107.648V14.04H109.878V17.3956H137.355V14.04H139.585Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.616 6.41154C124.962 6.41154 126.053 5.37524 126.053 4.09689C126.053 2.81853 124.962 1.78223 123.616 1.78223C122.27 1.78223 121.179 2.81853 121.179 4.09689C121.179 5.37524 122.27 6.41154 123.616 6.41154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9583 36.0943C69.9837 35.9103 69.073 34.2828 68.7565 33.6589C68.6789 33.5058 68.6544 33.3325 68.6868 33.1636L69.0745 31.1092C69.0745 31.1092 69.9693 31.2615 69.9002 32.4519C69.893 32.5756 69.9182 32.6992 69.9628 32.8142L70.3052 33.7099L71.3179 32.9264L70.7626 31.3593C70.7626 31.3593 70.0196 31.5635 69.6355 31.4413C68.8472 31.1897 69.8808 30.5758 70.2074 30.5104C70.5339 30.4449 71.2532 30.184 71.5798 30.739C71.9063 31.2939 72.1027 31.6202 72.1027 31.6202C72.1027 31.6202 72.4623 30.3795 72.2171 27.6041C72.2063 27.479 72.5192 27.4819 72.6069 27.571C72.8702 27.8384 73.2895 28.6536 73.3118 31.1307C73.3118 31.1307 73.3557 28.2439 73.8513 27.947C74.2599 27.7019 74.4663 29.1151 74.1786 31.511C74.1786 31.511 74.7116 29.4364 75.0935 29.4328C75.7373 29.4264 75.1021 34.9736 73.4837 36.627L70.9605 36.0943H70.9583Z",
    fill: "#F9B384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0137 35.2451C73.985 35.5212 73.9533 35.7886 73.9188 36.0473V36.0502C73.8037 36.9703 73.6598 37.7927 73.493 38.4971C73.4843 38.5316 73.4786 38.5633 73.4699 38.5949C72.978 40.6105 72.8888 41.5968 71.2085 41.3322L69.4793 39.3655L69.462 39.3454L69.3354 39.2016L69.6865 38.1665L69.7325 38.0313L69.9914 37.278L70.0231 37.1802L70.4662 35.8834L70.6446 35.3573L74.0137 35.2451Z",
    fill: "#F9B384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8885 106.86L41.4483 108.235C38.4302 109.225 36.6701 110.361 36.5571 111.685H45.2843L45.9842 107.082C44.2169 107.514 42.7999 107.213 41.8885 106.86Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9832 103.443L41.8892 106.861C42.8005 107.214 44.2175 107.514 45.9848 107.083L46.4358 104.114L42.9832 103.443Z",
    fill: "#F9B384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9045 106.708L58.1606 103.228L54.0606 103.443L53.8369 106.652C55.5726 107.205 57.0076 106.988 57.9045 106.708Z",
    fill: "#F9B384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8357 111.686C62.7228 110.362 61.1813 108.547 57.8006 108.116L57.9042 106.708C57.0065 106.989 55.5723 107.205 53.8366 106.652L53.4849 111.686H62.8357Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5811 36.9883L49.6353 37.0228V29.5469H54.4315L54.4344 30.0041L54.4574 32.3733L54.4919 36.1774L54.5811 36.9883Z",
    fill: "#DACEC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4578 32.7326C53.5687 33.6671 51.2497 32.6118 50.2715 31.5824L54.4348 30.3633L54.4578 32.7326Z",
    fill: "#DACEC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6054 27.8219C55.6025 28.374 55.568 28.9519 55.4759 29.504C55.2342 31.0107 54.5955 32.3132 53.1224 32.3535C49.641 32.4541 48.6484 30.4644 47.9924 28.8369C47.3364 27.2066 48.4009 23.2875 48.4009 23.2875L52.9066 22.8418L55.381 24.8689C55.381 24.8689 55.6198 26.2462 55.6054 27.8219Z",
    fill: "#F1E6DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.133 27.9043C48.133 27.9043 49.1263 27.8583 49.2961 25.2964C51.072 25.8901 52.3696 25.3488 53.3982 24.1671C54.2757 25.3251 56.7314 25.6881 57.5615 23.3167C58.1606 21.6037 56.5063 19.0518 54.0966 20.5973C51.7352 19.4048 48.1531 19.4867 47.1224 22.4117C47.1224 22.4117 43.5388 24.0628 47.3331 27.698C47.4094 27.7706 48.133 27.905 48.133 27.905V27.9043Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8289 63.8574L59.0956 105.169H52.6694L54.2763 65.0816L55.2589 64.6266L61.8289 63.8574Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0933 58.205L40.5854 105.169H47.5871L54.252 66.1596L61.8291 63.8594L62.1643 55.5208L45.2853 55.1377L45.0933 58.205Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M46.0981 58.3067C49.9218 59.6782 58.8943 58.1104 60.7573 56.1998L59.4338 53.5537L44.6768 55.5133L46.0988 58.3059L46.0981 58.3067Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4135 55.5633C60.2898 55.615 60.1632 55.6696 60.0337 55.7185C58.6038 56.2993 56.9753 56.8083 55.2403 57.1447C54.2046 57.3488 53.1256 57.4869 52.0265 57.5386C50.3693 57.622 48.666 57.5127 46.98 57.1303L49.1235 37.1581L49.3853 34.7227C49.3853 34.7227 52.1905 38.1731 55.2835 34.3633L60.4135 55.5633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M52.0265 57.5388C50.3693 57.6222 48.666 57.5129 46.98 57.1305L49.1235 37.1583L49.8888 36.0527C51.7791 40.6475 53.7154 50.822 52.0265 57.5388Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6367 33.9316C51.768 42.9746 52.6448 52.28 49.5051 62.6133C47.1767 63.4982 44.6412 63.4881 41.9288 62.7089L42.5999 43.9235L26.7991 54.7779L25.8403 48.8598C31.914 43.0559 42.4157 34.2875 49.6367 33.9316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M60.0336 55.718C58.6037 56.2988 56.9752 56.8078 55.2403 57.1442C54.2879 51.6868 54.0779 42.7214 54.8518 38.6758L60.0336 55.718Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M73.4928 38.4976C73.4842 38.5321 73.4784 38.5637 73.4698 38.5953C72.9778 40.611 72.8886 41.5972 71.2084 41.3327L69.4792 39.3659L69.4619 39.3458L69.6863 38.1669L69.7324 38.0318L69.9913 37.2784L70.023 37.1807L73.4928 38.4976Z",
    fill: "#E28B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1936 40.3297C73.1936 40.3297 68.9497 49.3152 66.4322 49.5308C63.9916 49.74 62.8357 47.3743 62.8357 47.3743L64.562 60.506C62.5336 61.4549 60.3211 61.9178 57.7518 61.4635C55.4702 54.0595 54.6077 44.486 54.438 33.8242C56.2851 33.9392 59.9435 34.0967 61.2533 34.9384C63.6032 36.448 66.5041 41.8393 66.5041 41.8393L69.8848 37.2387L73.1936 40.3297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6534 27.4709C48.611 27.3164 47.9089 27.1043 47.7543 27.0612C47.5148 26.995 47.2537 26.9627 47.0206 27.0684C46.1711 27.4522 46.2848 28.6678 46.725 29.3068C46.9746 29.6691 47.3393 29.9473 47.7636 30.0688C47.9176 30.1126 49.3792 30.1306 49.3152 29.8956C49.3152 29.8948 48.6548 27.4767 48.6534 27.4709Z",
    fill: "#F1E6DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9081 51.903C21.6873 51.2101 20.9608 50.8219 20.2732 51.0591C19.2021 51.4286 18.2692 52.0554 18.1254 53.1222C17.9937 54.0933 18.48 57.1958 20.6508 57.5941L20.4739 56.0004C20.4739 56.0004 21.8031 55.6906 22.0685 55.1148C22.2548 54.7115 22.2671 53.0287 21.9081 51.9037V51.903Z",
    fill: "#F9B384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1718 41.2334C62.2861 41.912 62.3833 42.5934 62.476 43.2742C62.5724 43.9549 62.6494 44.6385 62.7364 45.3207L62.9594 47.3716C63.0241 48.0559 63.0882 48.7409 63.1299 49.4282L63.0184 49.4411C62.9004 48.7625 62.8048 48.0818 62.7098 47.4003L62.453 45.3538C62.3804 44.6702 62.2977 43.9873 62.2344 43.3029C62.1675 42.6186 62.1049 41.9335 62.0596 41.2463L62.1711 41.2334H62.1718Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8235 41.1227C42.8221 41.8854 42.8034 42.6466 42.7811 43.4079C42.7616 44.1691 42.7228 44.9304 42.694 45.6909L42.5696 47.9725C42.5185 48.7323 42.466 49.4928 42.3926 50.2512L42.2804 50.2462C42.2783 49.4835 42.2977 48.7222 42.3193 47.9603L42.4106 45.6772C42.4545 44.9167 42.4869 44.1562 42.5394 43.3956C42.589 42.6358 42.6422 41.8753 42.7127 41.1162L42.8249 41.1212L42.8235 41.1227Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0459 28.3947C47.8625 28.2703 47.6942 28.1337 47.5273 28.0532C47.4446 28.0122 47.3669 27.9878 47.2986 27.9936C47.2288 27.9986 47.149 28.0396 47.0591 28.1035L46.9648 28.0424C47.0037 27.9274 47.0864 27.7987 47.2382 27.7484C47.3885 27.696 47.5417 27.7384 47.6546 27.7966C47.8841 27.9217 48.0402 28.1057 48.1359 28.3264L48.0467 28.3947H48.0459Z",
    fill: "#DACEC4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M22.0687 55.1133L20.733 59.1682L20.4575 55.9996C21.2876 55.8192 21.7407 55.4871 22.0687 55.1133Z",
    fill: "#6F3428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 111.713H186",
    stroke: "#EBEBEB",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6587 24.1029C20.6587 24.1029 20.9155 19.8042 21.3535 20.007C21.7916 20.2097 22.6691 23.9476 22.6691 23.9476L21.7304 25.4615L20.6587 24.1029Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5745 101.723L33.7018 103.138C33.9263 105.635 32.0827 107.842 29.5839 108.066L29.2199 108.099C26.7211 108.323 24.5129 106.481 24.2884 103.983L24.1611 102.568L33.5745 101.723V101.723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4137 33.2228L18 34.0674L24.1538 102.57L33.5674 101.726L27.4137 33.2228Z",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5731 101.724L24.1618 102.569L23.9144 99.809L23.7417 97.8912L23.2095 91.9967L32.6236 91.1514L33.153 97.0458L33.3256 98.9637L33.5731 101.724Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1594 97.0426L23.748 97.8887L23.9207 99.8067L33.332 98.9607L33.1594 97.0426Z",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.001 34.0664L20.6156 23.5937C20.6156 23.5937 21.5183 23.9941 22.6131 23.3184L27.4151 33.2218L18.001 34.0671V34.0664Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42272_105379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 186,
    height: 112,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedEmpty);
export default __webpack_public_path__ + "static/media/CompletedEmpty.55b954f336ee94a8e2be3230506d0527.svg";
export { ForwardRef as ReactComponent };